import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'

Vue.use(HighchartsVue)

import './chartOptions.js'
import './styles/common.scss'

import App from './components/HospitalMap'

Vue.config.productionTip = false

const appName = '2020-03-coronahospitalized'

const eventHandlers = {
  onMount: (name, element, services = {}) => {
    if (name !== appName) return;
    if (!element.querySelector(`#app-${appName}`)) return;

    const parameters = services.getParameters() || {};

    new Vue({
      render: h => h('div', { attrs: { id: 'app-2020-03-corona' } }, [
        h(App, {
          props: {
            // parameters passed from the SYND shortcode can be accessed like this
            articleUrl: parameters.url || null,
          }
        })
      ])
    }).$mount(`#app-${name}`)
  }
};

const yddvizAppMethods = {
  embedYlePlayer: function(elem, id, options) {
    window.ylePlayer.render({
      element: elem,
      props: {
        id: id,
        playFullScreen: !!options.playFullScreen,
      },
    });
  },
  getParameters: function() {
    const parameters = {};
    const searchParameters = new URLSearchParams(window.location.search);
    for (const [key, value] of searchParameters) {
      parameters[key] = value;
    }
    return parameters;
  },
};

if (process.env.NODE_ENV === 'production' && window.yleVisualisation) {
  // SYND OR FYND
  window.yleVisualisationEmbeds = window.yleVisualisationEmbeds || {};
  window.yleVisualisationEmbeds[appName] = eventHandlers;
}
else {
  eventHandlers.onMount(appName, document.body, yddvizAppMethods);
}
